import React from "react"

const ImagePlaceholder = ({ width, height, aspectRatio }) => (
  <div style={{ width, height, aspectRatio, backgroundColor: "#48A9A6" }} />
)

export default ImagePlaceholder
